<small *ngFor="let shiftHour of shiftHours" [style.margin-left]="gridHelper.getHourLabelOffset(shiftHour)" class="shift-index float-left">
  {{ gridHelper.getHourLabel(shiftHour) }}
</small>
<div *ngFor="let shiftHour of shiftHours" [style.margin-left]="gridHelper.getHourOffset(shiftHour)" class="grid-lines float-left">
</div>
<div class="chart">
  <div class="background-layer production" [style.width]="getBackgroundLayerWidth()"></div>
  <div *ngFor="let loss of losses" [style.margin-left]="getLossOffset(loss)" [style.width]="getLossWidth(loss)"
    [ngClass]="getLossColorClass(loss)" class="record float-left"></div>
</div>